import React from 'react';
import LoginBg from '../Components/Layout/LoginBg';
import './Login.css'

import Logo from '../Assets/Imgs/LogoWhite.svg'
import LoginForm from '../Components/Layout/LoginForm';

const Login = () => {
    return ( 
        <main className='Login'>

            <div className='BgContainer'>
                <LoginBg
                speed={5}
                scale={1}
                color="#33cc16"
                noiseIntensity={1.5}
                rotation={0}
                />
            </div>

            <div className='LoginContent'>
                <img src={Logo} alt="" />

                <LoginForm />

                
                
            </div>
        
        </main>
     );
}
 
export default Login;